import React from 'react';
import { useLanguage } from '../../LanguageContext';

// Deterministic pseudo-random points so the audience dots are stable between renders.
function seeded(n: number) {
  let s = 7;
  const out: {
    x: number;
    y: number;
  }[] = [];
  for (let i = 0; i < n; i++) {
    s = (s * 9301 + 49297) % 233280;
    const a = s / 233280;
    s = (s * 9301 + 49297) % 233280;
    const b = s / 233280;
    // concentrate in the targeted sector (lower-centre), with some spread
    const x = 120 + a * 190 + Math.sin(i) * 12;
    const y = 70 + b * 210;
    out.push({
      x,
      y
    });
  }
  return out;
}
const DOTS = seeded(120);
export function AudienceMap({
  className = ''
}: {
  className?: string;
}) {
  const {
    lang
  } = useLanguage();
  return <svg viewBox="0 0 420 340" className={className} role="img" aria-label={lang === 'FR' ? 'Carte du secteur ciblé' : 'Targeted sector map'} data-id="element-2646" data-mp="1xwwrn7i2n6we">
      <defs data-id="element-2647" data-mp="10emzy1hr59vh">
        <filter id="cm-blur" x="-50%" y="-50%" width="200%" height="200%" data-id="element-2648" data-mp="15fkem43jzls8">
          <feGaussianBlur stdDeviation="22" data-id="element-2649" data-mp="15dhh6z02mqdh" />
        </filter>
        <radialGradient id="cm-fade" cx="50%" cy="50%" r="55%" data-id="element-2650" data-mp="u5j2b94r1wmq">
          <stop offset="70%" stopColor="#fff" stopOpacity="0" data-id="element-2651" data-mp="q58vxvd1p47c" />
          <stop offset="100%" stopColor="#fff" stopOpacity="1" data-id="element-2652" data-mp="q5sd39uvfokb" />
        </radialGradient>
        <clipPath id="cm-clip" data-id="element-2653" data-mp="lcpjx2u0ah4n">
          <path d="M40 60 L150 20 L330 40 L395 150 L360 300 L180 330 L50 280 L20 170 Z" data-id="element-2654" data-mp="gf77h2gs5jrw" />
        </clipPath>
      </defs>

      <g clipPath="url(#cm-clip)" data-id="element-2655" data-mp="bgm6v1xm8y2x">
        <rect width="420" height="340" fill="#F6F6FA" data-id="element-2656" data-mp="bgw151pp1ref" />
        {/* parks */}
        <path d="M40 90 L110 70 L125 140 L55 160 Z" fill="#DDEFDF" data-id="element-2657" data-mp="6gqanov5uaxx" />
        <path d="M300 220 L360 210 L370 270 L310 285 Z" fill="#DDEFDF" data-id="element-2658" data-mp="2fehj9d2v7kz" />
        <path d="M150 40 L200 30 L208 70 L158 80 Z" fill="#E4F1E4" data-id="element-2659" data-mp="2himzvqmkend" />
        {/* street grid (rotated) */}
        <g transform="rotate(-18 210 170)" stroke="#E3E3EC" strokeWidth="1.2" data-id="element-2660" data-mp="3to26s0efvext">
          {Array.from({
          length: 22
        }).map((_, i) => <line key={`v${i}`} x1={-40 + i * 24} y1="-60" x2={-40 + i * 24} y2="420" data-id="element-2661" data-mp="1rtt7ty3qv2il" data-mpi={i} />)}
          {Array.from({
          length: 20
        }).map((_, i) => <line key={`h${i}`} x1="-60" y1={-40 + i * 24} x2="480" y2={-40 + i * 24} data-id="element-2662" data-mp="2awv004w3r2eq" data-mpi={i} />)}
        </g>
        <g transform="rotate(-18 210 170)" stroke="#FFFFFF" strokeWidth="4" opacity="0.9" data-id="element-2663" data-mp="2fris0dqbeey2">
          <line x1="-40" y1="140" x2="480" y2="140" data-id="element-2664" data-mp="21w6n5dig383f" />
          <line x1="200" y1="-60" x2="200" y2="420" data-id="element-2665" data-mp="26yfek5fo623f" />
        </g>
        {/* heatmap */}
        <g filter="url(#cm-blur)" data-id="element-2666" data-mp="2umoyf1tbofrx">
          <ellipse cx="220" cy="110" rx="70" ry="40" fill="#F4A3B8" opacity="0.55" data-id="element-2667" data-mp="2unq8b2ylqw82" />
          <ellipse cx="200" cy="220" rx="110" ry="70" fill="#6D5DF6" opacity="0.55" data-id="element-2668" data-mp="2yn8vy6ht5lel" />
          <ellipse cx="270" cy="170" rx="60" ry="50" fill="#A99CF9" opacity="0.5" data-id="element-2669" data-mp="2knpn1bh6a618" />
          <ellipse cx="300" cy="120" rx="40" ry="30" fill="#F4A3B8" opacity="0.4" data-id="element-2670" data-mp="2pnc7o5zbyok2" />
        </g>
        {/* targeted sector outline */}
        <path d="M110 110 L230 70 L320 110 L330 240 L220 300 L120 260 Z" fill="#6D5DF6" fillOpacity="0.06" stroke="#8B7FF7" strokeWidth="1" strokeDasharray="3 3" data-id="element-2671" data-mp="198102k3x570f" />
        {/* audience points */}
        {DOTS.map((d, i) => <circle key={i} cx={d.x} cy={d.y} r={i % 5 === 0 ? 2.2 : 1.5} fill="#4F46E5" opacity={0.55 + i % 4 * 0.1} data-id="element-2672" data-mp="11pky7u2741uk" data-mpi={i} />)}
        <rect width="420" height="340" fill="url(#cm-fade)" data-id="element-2673" data-mp="1fnhz32nomuf1" />
      </g>
    </svg>;
}